<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :data="tableData"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      :loading="loading"
      :height="400"
      size="small"
      resizable
      row-id="amzSkuCode"
      :checkbox-config="{
        highlight: true,
        reserve: true,
        checkMethod: ({ row }) => this.isMany,
      }"
      @cell-click="onCellClick"
      @checkbox-change="onCheckboxChange"
      @checkbox-all="onCheckboxChange"
    >
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg'
          "
          :preview-src-list="[
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic-square.jpg',
          ]"
          style="width:60px; height:60px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic-square.jpg"
              style="width:60px; height:60px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.amzSkuStatus === 'D'
              ? 'danger'
              : row.amzSkuStatus === 'Q'
              ? 'primary'
              : row.amzSkuStatus === 'P'
              ? 'warning'
              : row.amzSkuStatus === 'C'
              ? 'confirm'
              : 'success'
          "
        >
          {{ row.v_amzSkuStatus }}
        </el-tag>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.goodsName }}</span>
        <br />
        <span>{{ row.goodsNameEn }}</span>
        <br />
        <span>SKU:</span><span style="color: #409EFF">{{ row.amzSkuNo }}</span>
      </template>
      <template v-slot:displayBrand="{ row }">
        <span style="color: #303133">{{ row.brandName }}</span>
        <br />
        <span style="color: #303133">{{ row.categoryFullName }}</span>
        <br />
        <span style="color: #303133">{{ row.collectionName }}</span>
      </template>
      <template v-slot:displayColor="{ row }">
        <span style="color: #303133">{{ row.goodsSize }}</span>
        <br />
        <span style="color: #303133"
          >{{ row.goodsColor }} &nbsp; {{ row.goodsColorEn }}</span
        >
        <br />
        <span style="color: #303133">{{ row.goodsPattern }}</span>
      </template>
      <template v-slot:displayUnit="{ row }">
        <span>UNIT:</span
        ><span style="color: #303133"
          >{{ row.unitLength }}x{{ row.unitWidth }}x{{
            row.unitHeight
          }}
          cm</span
        >
        <br />
        <span>N.W:</span
        ><span style="color: #303133">{{ row.goodsWeight }} kg</span>
        <br />
        <span>G.W:</span
        ><span style="color: #303133">{{ row.unitWeight }} kg</span>
        <br />
        <span>CBM:</span
        ><span style="color: #303133">{{ row.unitCbm }} m³</span>
      </template>
      <template v-slot:displayBox="{ row }">
        <span
          >CTN:{{ row.ctnLength }}x{{ row.ctnWidth }}x{{
            row.ctnHeight
          }}
          cm</span
        >
        <br />
        <span>N.W:{{ row.ctnNetWeight }} kg</span>
        <br />
        <span>G.W:{{ row.ctnGrossWeight }} kg</span>
        <br />
        <span>CBM:{{ row.ctnCbm }} m³</span>
      </template>
      <template v-slot:designAndBuyer="{ row }">
        <span>PM：</span
        ><span style="color: #303133">{{ row.designName }}</span>
        <br />
        <span>PC：</span><span style="color: #303133">{{ row.buyerName }}</span>
      </template>
      <template v-slot:displayFactory="{ row }">
        <span>NC:</span><span style="color: #303133">{{ row.ncNo }}</span>
        <br />
        <span style="color: #303133">{{ row.scmName }}</span>
      </template>
      <template v-slot:isVc="{ row }">
        <el-tag
          size="mini"
          v-if="row.isVc"
          :type="row.isVc === 'N' ? 'info' : 'warning'"
        >
          {{ row.v_isVc }}
        </el-tag>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:modifyInfo="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
      <template v-slot:toolbar_form>
        <slot name="header">
          <Header
            ref="header"
            :addSku="addSku"
            :disabled="disabled"
            :isMany="isMany"
            :checkedCount="checkedCount"
            @chooseAmzSkuVisible="
              () => {
                chooseAmzSkuVisible = true
              }
            "
            @handleCommand="
              handleCommand({
                opt: { pageType: 'add' },
                data: { amzSkuCode: '' },
              })
            "
            @remove="remove()"
          >
          </Header>
        </slot>
      </template>
    </vxe-grid>

    <ChooseAmzSku
      :visible.sync="chooseAmzSkuVisible"
      :amzSkuStatus="['Y']"
      :multiple="false"
      :extraData="extraData"
      :url="url"
      confirm-on-close
      reserve
      @confirm="setTableData"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import ChooseAmzSku from './choose-amz-sku'
import BaseTable from '@/mixins/base-table'
import Header from './header.vue'
export default {
  mixins: [EditLoading, BaseTable],
  components: { ChooseAmzSku, Header },
  props: {
    disabled: { type: Boolean, default: false },
    isMany: { type: Boolean, default: false },
    amzSpuCode: { type: String, default: '' },
    addSku: { type: Boolean, default: false },
    extraData: { type: Object, default: () => {} },
  },
  data() {
    return {
      loading: false,
      checkedCount: 0,
      updateDesignVisible: false,
      // multiple: true,
      checkedRow: [],
      url: '/ecom/amz/sample/amz/page/list',
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        // refresh: { query: () =>  this.$refs.header.query() },
      },
      tableColumns: tableColumns(this),
      chooseAmzSkuVisible: false,
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSampleAmzListApi({
          ...form,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.resetChecked()
        })
        .catch(() => {
          this.loading = false
        })
    },

    setTableData(data) {
      this.tableData = data
      this.resetChecked()
    },

    openRadioVisible() {
      this.chooseAmzSkuVisible = true
      // this.multiple = false
    },
    clearSkuTable() {
      this.tableData = []
      this.resetChecked()
    },
    resetChecked() {
      this.$refs.vxeGrid.clearCheckboxRow()
      this.$refs.vxeGrid.clearCheckboxReserve()
      this.checkedCount = 0
      this.checkedRow = []
    },
    remove() {
      if (!this.checkedRow || !this.checkedRow.length) {
        this.$message({
          message: '请选择需要移除的SKU产品',
          type: 'warning',
        })
        return
      }
      this.$confirm(
        '是否要移除所选产品？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(async () => {
        await this.$refs.vxeGrid.removeCheckboxRow()
        await this.resetChecked()
        await this.reassign()
      })
    },
    async reassign() {
      const tableData = await this.getTableData()
      this.tableData = tableData
    },
    async getTableData() {
      const { tableData } = await this.$refs.vxeGrid.getTableData()
      return tableData
    },
    async validate() {
      const tableData = await this.getTableData()
      if (!tableData || !tableData.length) {
        // this.$message.error(this.$l('tips_pleaseAddSku') || '请选择SKU产品')
        this.$message.error('请选择SKU产品')
        return false
      }
      const result = await this.$refs.vxeGrid.validate(true)
      return !result
    },
    onCheckboxChange({ records }) {
      this.checkedRow = records
      this.checkedCount = !records ? 0 : records.length
    },
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['checkbox', 'col-opt']
      if (filterColumns.includes(property)) return
      this.$refs.vxeGrid.toggleCheckboxRow(row)
      const data = this.$refs.vxeGrid.getCheckboxRecords(true)
      this.checkedRow = data
      this.checkedCount = !data ? 0 : data.length
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .vxe-table--main-wrapper {
  // margin-top: 20px;
}
::v-deep {
  .el-tag--confirm {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
